import { useMemo } from 'react'

import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import { Text } from '@interco/inter-ui/components/Text'

export const RootError = () => {
  const error = useRouteError()

  const errorAsString = useMemo(
    () =>
      isRouteErrorResponse(error) ? error.data : (error as Record<string, unknown>)?.toString(),
    [error],
  )
  return (
    <div>
      <Text variant="headline-h1">Ops...</Text>
      <Text variant="body-1">Ocorreu um erro, e já vamos resolver.</Text>
      <div
        style={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <details>
          <summary>Mais informações.</summary>

          <p>{errorAsString}</p>
        </details>
      </div>
    </div>
  )
}

export default RootError
